var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7C2",
  d: "M19.8 9.394c-.2-1.3-.8-2.2-2.2-2.4-2.2-.4-5.6-.4-5.6-.4s-3.4 0-5.6.4c-1.4.2-2.1 1.1-2.2 2.4-.2 1.3-.2 3.2-.2 3.2s0 1.9.2 3.2.8 2.2 2.2 2.4c2.2.4 5.6.4 5.6.4s3.4 0 5.6-.4c1.4-.3 2-1.1 2.2-2.4s.2-3.2.2-3.2 0-1.9-.2-3.2m-9.8 6.2v-6l5 3z"
})));
export default SvgUploadYoutube;